var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryMobileWork = function SvgCategoryMobileWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_mobile_work_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_mobile_work_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_work_svg__st0",
    d: "M31.4 30.7H16.6c-1 0-1.9-.8-1.9-1.9v-8.3c0-1 .8-1.9 1.9-1.9h14.8c1 0 1.9.8 1.9 1.9v8.2c0 1.1-.8 2-1.9 2zM19.6 21.8v2.9M28.2 21.8v2.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_work_svg__st0",
    d: "M20.8 18.7v-2c0-.6.6-1 1.3-1h3.6c.7 0 1.2.4 1.2.9v1.8M15 23.3h18.1"
  })));
};
export default SvgCategoryMobileWork;